// client/utils/loadCustomerConfig.js

let _cache = null;
let _cacheCustomerId = null;

/**
 * Load customer configuration (client-side)
 * - Cached (no re-fetch)
 * - Loads customer-specific cfg.json
 * - Falls back to /config/default/cfg.json
 * - Works in Vite dev + production
 */
export async function loadCustomerConfig() {
  const customerId = localStorage.getItem("customer_id") || "default";

  // Return cached config for same customer
  if (_cache && _cacheCustomerId === customerId) {
    return _cache;
  }

  const customerPath = `/config/customer_${customerId}/cfg.json`;
  const fallbackPath = `/config/default/cfg.json`;

  try {
    const res = await fetch(customerPath);

    if (!res.ok) {
      throw new Error(`Customer config not found: ${customerPath}`);
    }

    const config = await res.json();

    // Cache for next time
    _cache = config;
    _cacheCustomerId = customerId;

    return config;

  } catch (err) {
    console.warn(
      `⚠ Customer config for '${customerId}' missing, falling back to default.`,
      err
    );

    try {
      const fallbackRes = await fetch(fallbackPath);
      if (!fallbackRes.ok) {
        throw new Error("Default config missing!");
      }

      const fallback = await fallbackRes.json();

      _cache = fallback;
      _cacheCustomerId = "default";

      return fallback;

    } catch (fallbackErr) {
      console.error("❌ FATAL: Could not load default cfg.json!", fallbackErr);

      // prevent front-end crash
      const empty = {};
      _cache = empty;
      _cacheCustomerId = "default";
      return empty;
    }
  }
}
